export default {
  title: 'Yleiskatsaus',
  table_title: 'Varaukset',
  filters: {
    card_title: 'Suodattimet',
    today: 'Tänään',
    upcoming: 'Tulevat',
    past: 'Menneet',
    all: 'Kaikki',
    all_dates: 'Koko ajalta',
    pending: 'Odottaa vahvistusta',
    canceled: 'Peruttu',
    removed: 'Poistettu',
    date_label: 'Päivä:',
    status_label: 'Tila:',
    source_label: 'Lähde:',
    source_website: 'Verkkosivu',
    source_google: 'Google',
    search_label: 'Haku:',
    search_placeholder: 'Hae etu- tai sukunimellä',
    custom_date_tooltip: 'Valitse tietty päivä',
    active_label: 'Aktiiviset suodattimet:',
    clear_all: 'Tyhjennä kaikki',
  },
  tooltips: {
    total_reservations: 'Varauksia yhteensä',
    total_guests: 'Vieraita yhteensä',
    refresh: 'Päivitä',
  },
  empty: {
    default: 'Ei vielä varauksia.',
    filtered: 'Ei suodattimia vastaavia varauksia.',
  },
  fields: {
    company: 'Ravintola',
    datetime: 'Päivä / aika',
    customer: 'Asiakas',
    source: 'Lähde',
    guests: 'Vieraat',
    status: 'Tila',
    created_at: 'Luotu',
  },
  status: {
    confirmed: 'Vahvistettu',
    pending: 'Odottaa hyväksyntää',
    canceled: 'Peruttu',
    rejected: 'Hylätty',
    removed: 'Poistettu',
  },
  buttons: {
    details: 'Tiedot',
    add_reservation: 'Lisää varaus',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
